<div>
	<p-table #dt class="ping-devices-table" [value]="entries" dataKey="settingsEntryGuid"
			 [resizableColumns]="true"
			 [scrollable]="true" scrollHeight="calc(515px)"
			 [customSort]="true" (sortFunction)="doCustomSort($event)">

		<ng-template pTemplate="header">
			<tr>
				<th pResizableColumn pSortableColumn="deviceName">
					Device
					<p-sortIcon field="deviceName"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="deviceDescription">
					Device Description
					<p-sortIcon field="deviceDescription"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="ipAddress">
					IP Address
					<p-sortIcon field="ipAddress"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="hostname">
					Hostname
					<p-sortIcon field="hostname"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="stateDetails">
					State Details
					<p-sortIcon field="stateDetails"></p-sortIcon>
				</th>
				<th pResizableColumn pSortableColumn="state">
					State
					<p-sortIcon field="state"></p-sortIcon>
				</th>
				<th class="uv-table-button-column-4">
					<!-- Action Buttons -->
				</th>
			</tr>

			<tr class="uv-table-filter">
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'deviceName', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'deviceDescription', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'ipAddress', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'hostname', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'stateDetails', 'contains')">
				</th>
				<th>
					<input pInputText type="text" style="width: 100%;"
						(input)="dt.filter($event.target.value, 'state', 'contains')">
				</th>
				<th class="uv-table-button-column-4">
					<!-- Action Buttons -->
				</th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
			<tr [pSelectableRow]="rowData">
				<td>
					<span class="uv-table-value">{{rowData['deviceName']}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData['deviceDescription']}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData['ipAddress']}}</span>
				</td>
				<td>
					<span class="uv-table-value">{{rowData['hostname']}}</span>
				</td>
				<td pTooltip="{{rowData['stateDetails']}}">
					<span class="uv-table-value">{{rowData['stateDetails']}}</span>
				</td>
				<td [className]="rowData['style']">
					<span class="uv-table-value">{{rowData['state']}}</span>
				</td>
				<td class="uv-table-button-column-4">
					<button type="button" class="btn btn-primary uv-first-table-button" (click)="editSettings(rowData)"
							title="Edit the settings for this IP address">
						<i  class="fa fa-edit"></i>
					</button>
					<button type="button" class="btn btn-primary uv-table-button" [disabled]="!enableAddIpMonitor(rowData)" (click)="addIpMonitor(rowData)"
							title="Add another of this device's IP addresses">
						<i class="fa fa-plus-square-o"></i>
					</button>
					<button type="button" class="btn btn-danger uv-table-button" (click)="deleteIpMonitor(rowData)"
							title="Remove this IP address">
						<i class="fa fa-minus-square-o"></i>
					</button>
					<button type="button" class="btn btn-danger uv-table-button" title="Remove all IP addresses for this device"
							(click)="deleteDevice(rowData)">
						<i class="pi pi-trash"></i>
					</button>
				</td>
			</tr>
		</ng-template>

	</p-table>

	<div style="margin-top: 3px;">
		<button type="button" pButton class="pingdevices-table-button" (click)="addDevice()" icon="fa fa-plus-square-o" label="Add Device"></button>
		<button type="button" pButton class="pingdevices-table-button" (click)="refreshEntries()" icon="fa fa-refresh" label="Refresh"></button>
	</div>

	<monitor-device-selector header="Select Devices to Monitor" [(visible)]="deviceSelectorVisible"
							 (onOk)="onDeviceSelectorOk($event)" (onCancel)="onDeviceSelectorCancel()">
	</monitor-device-selector>

	<ping-entry [(visible)]="entryEditorVisible" [target]="entryEditorTarget"
				[create]="entryEditorCreate" [ipAddresses]="entryEditorIpAddresses"
				[showIpV6]="entryEditorShowIpV6"
				(onSave)="onEntryEditorSave()" (onCancel)="onEntryEditorCancel()"></ping-entry>

</div>